import React, { createContext, useContext, useState } from "react";

// Create context
const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [loginOpen, setLoginOpen] = useState(false);
  const [signupOpen, setSignupOpen] = useState(false);

  const openLogin = () => setLoginOpen(true);
  const closeLogin = () => setLoginOpen(false);

  const openSignup = () => setSignupOpen(true);
  const closeSignup = () => setSignupOpen(false);

  return (
    <ModalContext.Provider
      value={{
        loginOpen,
        openLogin,
        closeLogin,
        signupOpen,
        openSignup,
        closeSignup,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

// Custom hook to use modal context
export const useModal = () => useContext(ModalContext);
